import * as React from 'react';

function SvgAdd(props) {
  return (
    <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.469 1.376H6.53c-.083 0-.125.041-.125.125v4.906H1.75c-.083 0-.125.042-.125.125v.937c0 .084.042.125.125.125h4.656v4.907c0 .083.042.125.125.125h.938c.083 0 .125-.042.125-.125V7.594h4.656c.084 0 .125-.041.125-.125v-.937c0-.083-.041-.125-.125-.125H7.594V1.501c0-.084-.042-.125-.125-.125z"
        fill="#"
      />
    </svg>
  );
}

export default SvgAdd;
